import { PRESSABLE_OPACITY } from '@unistocks/shared/consts';
import { Label as TamaguiLabel, styled } from 'tamagui';

export const Label = styled(TamaguiLabel, {
  fontFamily: '$body',
  color: '$bodyFont',
  fontWeight: '$7',

  variants: {
    form: {
      true: {
        pressStyle: {
          opacity: PRESSABLE_OPACITY
        }
      }
    },

    invalid: {
      true: {
        color: '$danger',

        pressStyle: {
          opacity: PRESSABLE_OPACITY,
          color: '$danger'
        }
      }
    }
  } as const,

  defaultVariants: {
    form: true,
    invalid: false
  }
});
